import { Button, Modal, Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { Consent } from '../types';
import { useDeleteTellMoneyConsent } from '../useDeleteTellMoneyConsent';
import { ConsentDetails } from './ConsentDetails';

type RevokeConsentModalProps = {
    onClose: () => void;
    consent: Consent | null;
};

export const RevokeConsentModal = ({
    onClose,
    consent
}: RevokeConsentModalProps) => {
    const revokeMutation = useDeleteTellMoneyConsent();

    if (!consent) {
        return null;
    }

    const handleSubmit = () => {
        revokeMutation.mutate(consent.consent_id, {
            onSuccess: onClose
        });
    };

    return (
        <Modal
            isOpen={!!consent}
            onClose={onClose}
            title={
                <FormattedMessage
                    id="_.credit_card.preferences.consent_management.revoke_modal.title"
                    defaultMessage="Are you sure?"
                />
            }
            headerBar
            closeIcon
        >
            <div className="pb-xl">
                <ConsentDetails consent={consent} />
            </div>
            {revokeMutation.isError && (
                <Text size="s" className="text-error">
                    <FormattedMessage
                        id="_.credit_card.preferences.consent_management.revoke_modal.error"
                        defaultMessage="Failed to disconnect app, please try again later"
                    />
                </Text>
            )}
            <div className="space-x-s">
                <Button
                    variant="action"
                    onClick={handleSubmit}
                    loading={revokeMutation.isLoading}
                >
                    <FormattedMessage
                        id="_.credit_card.preferences.consent_management.revoke_modal.submit"
                        defaultMessage="Yes, disconnect"
                    />
                </Button>
                <Button
                    variant="tertiary"
                    onClick={onClose}
                    disabled={revokeMutation.isLoading}
                >
                    <FormattedMessage
                        id="_.credit_card.preferences.consent_management.revoke_modal.cancel"
                        defaultMessage="No, keep connection"
                    />
                </Button>
            </div>
        </Modal>
    );
};
